import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectorService {
  public isHandsetOrTablet$: Observable<boolean>;
  public isHandset$: Observable<boolean>;
  public isTablet$: Observable<boolean>;

  constructor(private readonly breakpointObserver: BreakpointObserver) {
    // Detecta si es móvil
    this.isHandset$ = this.breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(map((result) => result.matches));

    // Detecta si es tablet
    this.isTablet$ = this.breakpointObserver
      .observe([Breakpoints.Tablet])
      .pipe(map((result) => result.matches));

    // Detecta si es móvil O tablet
    this.isHandsetOrTablet$ = this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .pipe(map((result) => result.matches));
  }

  public isMobile(): Observable<boolean> {
    return this.isHandsetOrTablet$;
  }

  public isTablet(): Observable<boolean> {
    return this.isTablet$;
  }

  public isMobileOrTablet(): Observable<boolean> {
    return this.isHandsetOrTablet$;
  }
}
